export default __webpack_public_path__ + "static/jessica-02737fc94147b3f87fc5bb9318244fee.png";